"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sdk = void 0;
class Sdk {
    constructor(defaultFlags) {
        this.subscriptions = new Map();
        this.flags = defaultFlags;
    }
    onChange(property, handler) {
        var _a;
        if (!this.subscriptions.has(property)) {
            this.subscriptions.set(property, []);
        }
        (_a = this.subscriptions.get(property)) === null || _a === void 0 ? void 0 : _a.push(handler);
        handler(this.flags[property]);
        return () => {
            var _a, _b, _c;
            const idx = (_b = (_a = this.subscriptions.get(property)) === null || _a === void 0 ? void 0 : _a.indexOf(handler)) !== null && _b !== void 0 ? _b : -1;
            if (idx >= 0) {
                (_c = this.subscriptions.get(property)) === null || _c === void 0 ? void 0 : _c.splice(idx, 1);
            }
        };
    }
    updateFlag(property, value) {
        var _a;
        this.flags[property] = value;
        (_a = this.subscriptions.get(property)) === null || _a === void 0 ? void 0 : _a.forEach(callback => callback(value));
    }
}
exports.Sdk = Sdk;
//# sourceMappingURL=sdk_base.js.map